module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.5.8-250.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.5.8.md
// module id = 693
// module chunks = 268